






import { AccountContactQRTs } from './AccountContactQRTs';
export default class AccountContactQR extends AccountContactQRTs {}
